import React from "react"
import { Box, Grid, Typography } from "@mui/material"

/**
 * ============================================================================
 * SECTION HEADER FIELD
 * ============================================================================
 *
 * Supported Metadata Schema
 *
 * {
 *   "name": "Basic Information",
 *   "slug": "basic_information",
 *   "details": {
 *     "type": "section-header",
 *     "formatting": {
 *       "variant": "default",
 *       "description": null
 *     }
 *   }
 * }
 *
 * VISUAL
 *
 * Basic Information
 *
 * ============================================================================
 *
 * {
 *   "name": "Basic Information",
 *   "slug": "basic_information",
 *   "details": {
 *     "type": "section-header",
 *     "formatting": {
 *       "variant": "divider",
 *       "description": null
 *     }
 *   }
 * }
 *
 * VISUAL
 *
 * Basic Information
 * -----------------
 *
 * ============================================================================
 *
 * {
 *   "name": "Address Information",
 *   "slug": "address_information",
 *   "details": {
 *     "type": "section-header",
 *     "formatting": {
 *       "variant": "filled",
 *       "description": null
 *     }
 *   }
 * }
 *
 * VISUAL
 *
 * ┌──────────────────────────────┐
 * │ Address Information          │
 * └──────────────────────────────┘
 *
 * ============================================================================
 *
 * {
 *   "name": "Care Plan",
 *   "slug": "care_plan",
 *   "details": {
 *     "type": "section-header",
 *     "formatting": {
 *       "variant": "outlined",
 *       "description": null
 *     }
 *   }
 * }
 *
 * VISUAL
 *
 * [ Care Plan ]
 *
 * ============================================================================
 *
 * {
 *   "name": "Medical History",
 *   "slug": "medical_history",
 *   "details": {
 *     "type": "section-header",
 *     "formatting": {
 *       "variant": "border-left",
 *       "description": null
 *     }
 *   }
 * }
 *
 * VISUAL
 *
 * │ Medical History
 *
 * ============================================================================
 *
 * {
 *   "name": "Emergency Contact",
 *   "slug": "emergency_contact",
 *   "details": {
 *     "type": "section-header",
 *     "formatting": {
 *       "variant": "sub-section",
 *       "description": null
 *     }
 *   }
 * }
 *
 * VISUAL
 *
 * Emergency Contact
 *
 * ============================================================================
 *
 * Description Support
 *
 * {
 *   "name": "Address Information",
 *   "slug": "address_information",
 *   "details": {
 *     "type": "section-header",
 *     "formatting": {
 *       "variant": "divider",
 *       "description": "Enter complete address details"
 *     }
 *   }
 * }
 *
 * VISUAL
 *
 * Address Information
 * -------------------
 * Enter complete address details
 *
 * ============================================================================
 *
 * Supported Variants
 *
 * default
 * divider
 * filled
 * outlined
 * border-left
 * sub-section
 *
 * ============================================================================
 *
 * Example Usage In Asset Form
 *
 * {
 *   "name": "Basic Information",
 *   "details": {
 *     "type": "section-header",
 *     "formatting": {
 *       "variant": "divider",
 *       "description": "Enter patient's basic details"
 *     }
 *   }
 * }
 *
 * {
 *   "name": "First Name",
 *   "details": {
 *     "type": "text"
 *   }
 * }
 *
 * {
 *   "name": "Last Name",
 *   "details": {
 *     "type": "text"
 *   }
 * }
 *
 * ============================================================================
 */

const SectionHeaderField = ({ title, description, variant = "default" }) => {
    
    return (
            <Box className={`e-afm-section-header e-afm-section-header--${variant}`}>
                <div className="e-afm-section-header__title">{title}</div>

                {description && (
                    <div className="e-afm-section-header__description">{description}</div>
                )}
            </Box>
    )
}

export default React.memo(SectionHeaderField)
